/** Supported content drop behaviors for Explorer views. */
export enum ExplorerContentDropMode {
  /** Drops move an entity within the parent-child hierarchy. */
  Hierarchy = 'hierarchy',
}